import { RendererBaseProps } from '../index';
import { ImagePage } from './ImagePage';

export const ImageRenderer = ({
  caseId,
  docId,
  getPageDimensions,
  visiblePages,
  getPagePosition,
  highlights,
  highlightedFactId,
  onHighlightClick,
  highlightedChunkId,
  totalHeight,
  isSelectionMode,
  onSelectionComplete,
  maintainSelection,
  activeSelection,
}: RendererBaseProps) => {
  return (
    <div className="relative w-full" style={{ height: totalHeight }}>
      {visiblePages.map((pageNumber) => {
        const pageDims = getPageDimensions(pageNumber);

        return (
          <ImagePage
            key={pageNumber}
            pageNumber={pageNumber}
            top={getPagePosition(pageNumber)}
            dimensions={{ height: pageDims.height, width: pageDims.width }}
            highlights={highlights}
            highlightedFactId={highlightedFactId}
            onHighlightClick={onHighlightClick}
            highlightedChunkId={highlightedChunkId}
            caseId={caseId}
            docId={docId}
            isSelectionMode={isSelectionMode}
            onSelectionComplete={onSelectionComplete}
            maintainSelection={maintainSelection}
            activeSelection={activeSelection}
          />
        );
      })}
    </div>
  );
};
